<button (click)="editData(params)" [title]="editToolTip" *ngIf="isEditVisible" [disabled]="isEditDisabled" style="padding-right: 10px">
  <img src="../assets/edit.svg" height="25" width="25" alt="Edit Icon" />
</button>
<button (click)="copyData(params)" title="Copy" *ngIf="isCopyVisible" style="padding-right: 10px">
  <img src="../assets/icons/copy.svg" height="22" width="22" alt="Copy Icon" />
</button>
<button (click)="forwardConfiguration(params)" title="Forward" *ngIf="isForwardVisible" style="padding-right: 5px">
  <img src="../assets/icons/Forward.svg" height="25" width="25" alt="ForwardIcon"/>
</button>
<button (click)="delData(params)" title="Delete" *ngIf="isDelVisible" >
  <img src="../assets/icons/delete.svg" height="25" width="25" alt="DeleteIcon" />
</button>
<button (click)="AccessMangementData(params)" title="Configure access rights" *ngIf="isAccessVisible" style="padding-left: 10px" >
  <img src="../assets/access-key.svg" height="25" width="25" alt="AccessMangementIcon" />
</button>
